import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SearchPanel from '../Components/SearchPanel';
import FilterPanel from '../Components/FilterPanel';
import MultiRangeSlider from "../../../../Utility/Components/MultiRangeSlider";
import Pagination from 'react-bootstrap/Pagination';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Utility from '../../../../Utility/Utility';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import { loaderStateTrue, loaderStateFalse, selectChooseBranch, userSearchData, roleWisePermission } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter, useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal'
import ReviewContentShowModal from '../Components/ReviewContentShowModal';
import {
  hotelRoomTypesSearchList,
  destinationList
} from '../Controller/HomeController';
import BreadcrumbMenu from '../../../../Utility/Components/BreadcrumbMenu';
import Tooltip from 'react-bootstrap/Tooltip';
import SkeletonThemeContentList from '../../../../Utility/Components/SkeletonThemeContentList';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import CancellationDetailsModalContent from '../Components/CancellationDetailsModalContent';
import HotelListItems from '../Components/HotelListItems';
import { serachDataFormatingFn } from '../Model/HomeModel';
function SearchPage(props) {
  // console.group('SearchPage......'); // Commented out to reduce console noise
  const myParam = useParams();
  const [isViewportBottom, setIsViewportBottom] = useState(false);
  const [showAllFlag, setShowAllFlag] = useState(false);
  const [leftSearchFlag, setLeftSearchFlag] = useState("hide-bar");
  const [searchResult, setsearchResult] = useState([]);
  const [searchingDataFromSearchPanel, setSearchingDataFromSearchPanel] = useState({})
  const [dataFromFilterPanel, setDataFromFilterPanel] = useState({})
  const history = useHistory();
  const [reviewShowModalFlag, setReviewShowModalFlag] = useState(false)
  const [ratingDataArr, setRatingDataArr] = useState([])
  const [apiCallFinish, setApiCallFinish] = useState(false)
  const [filterApiCallSuccess, setFilterApiCallSuccess] = useState(false)
  const [overlay, setOverlay] = useState(true)
  const [viewCancellationData, setViewCancellationData] = useState([])
  const [viewCancellationDetailsModalFlag, setViewCancellationDetailsModalFlag] = useState(false)
  const isFilterTriggeredUrlChange = React.useRef(false);

  const [selectedDestination, setSelectedDestination] = useState('');
  const [selectedTheme, setSelectedTheme] = useState('');
  const [selectedNavTag, setSelectedNavTag] = useState('');
  const isInitialMount = React.useRef(true);

  useEffect(() => {
    setSelectedDestination('');
    setSelectedTheme('');
    setSelectedNavTag('');
    localStorage.removeItem('selectedDestination');
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('selectedDestination');
    }
    localStorage.removeItem('selectedTheme');
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('selectedTheme');
    }
    localStorage.removeItem('selectedNavTag');
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('selectedNavTag');
    }
    if (props.selectedNavTagAction) {
      props.selectedNavTagAction('');
    }
  }, []);

  useEffect(() => {
    if (props.selectedNavTagFromReducer !== undefined && props.selectedNavTagFromReducer !== selectedNavTag) {
      setSelectedNavTag(props.selectedNavTagFromReducer || '');
    }
  }, [props.selectedNavTagFromReducer]);

  useEffect(() => {
    const handleSelectionChange = (e) => {
      setSelectedDestination(localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '');
      setSelectedTheme(localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '');
      const navTag = e?.detail?.type === 'navTag' ? (e.detail.option || '') : (localStorage.getItem('selectedNavTag') || '');
      setSelectedNavTag(navTag);
    };
    window.addEventListener('sectionSelectionChange', handleSelectionChange);
    return () => {
      window.removeEventListener('sectionSelectionChange', handleSelectionChange);
    };
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    searchHotelBranch();
  }, [selectedDestination, selectedTheme, selectedNavTag]);

  //show review modal fn
  const showReviewModalFn = (data) => {
    setReviewShowModalFlag(true)
    setRatingDataArr(data)
  }

  //close review modal fn
  const closeReviewModalFn = () => {
    setReviewShowModalFlag(false)
    setRatingDataArr([])
  }

  //Initially fetch user loggedin or not
  useEffect(() => {
    if (!props.isLoggedIn) {
    } else {
      sessionStorage.setItem('previousUrl', `/${localStorage.getItem('i18nextLng')}/search`);
    }
  }, [props.isLoggedIn]);

  // Note: URL parameter parsing is now handled by handleUrlParams function called from the mount useEffect

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      if (scrollTop >= 1050) {
        setIsViewportBottom(true);
      } else {
        setIsViewportBottom(false);
      }
      if (scrollPosition + windowHeight > documentHeight - 600) {

        setIsViewportBottom(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showAllFN = () => {
    setShowAllFlag(!showAllFlag);
  }

  //filter bar show hide for mobile fn
  const mobFilterFN = () => {
    if (leftSearchFlag == "hide-bar") {
      setLeftSearchFlag("show-bar");
    } else {
      setLeftSearchFlag("hide-bar");
    }
  }

  //filter bar hide cross buttton click for mobile fn
  const crossFN = () => {
    setLeftSearchFlag("hide-bar");
  }

  //search data validation fn
  const validSearchData = () => {
    const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
    let valid = true
    if ((userSearchDataFromReducer.end_date != "" || userSearchDataFromReducer.end_date != null) && (userSearchDataFromReducer.start_date != "" || userSearchDataFromReducer.start_date != null)) {
      const startDate = new Date(userSearchDataFromReducer.start_date);
      const endDate = new Date(userSearchDataFromReducer.end_date);
      const timeDifference = endDate.getTime() - startDate.getTime();
      const differenceInDays = timeDifference / (1000 * 3600 * 24);
      if (differenceInDays > 30) {
        valid = false;
        Utility.toastNotifications("Sorry, reservations for more than 30 nights are not possible.", "Warning", "warning");
      }
    }
    return valid;
  }


  //when some filteration done then hotel search occure
  useEffect(() => {
    if (filterApiCallSuccess) {
      const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
      if (userSearchDataFromReducer?.start_date && userSearchDataFromReducer.start_date != "" && userSearchDataFromReducer?.end_date && userSearchDataFromReducer.end_date != "" &&
        // && userSearchDataFromReducer?.destination && userSearchDataFromReducer.destination != "" && 
        userSearchDataFromReducer?.adult && userSearchDataFromReducer.adult != "") {
        // let allAgesNotEmpty = userSearchDataFromReducer?.children_age?.every(child => child.age !== "");
        let valid = validSearchData();
        if (valid) {
          setFilterApiCallSuccess(false);
          searchHotelBranch();
        } else {
          setsearchResult([])
          setApiCallFinish(true)
          setTimeout(() => {
            setOverlay(false)
          }, 500);
        }
      } else {
        // Incomplete data (e.g. user is mid date-selection): don't navigate away.
        setFilterApiCallSuccess(false);
      }
    }
  }, [filterApiCallSuccess])

  //check filter data will populate or not 
  const filterApiSuccessCheckFn = (data) => {
    setFilterApiCallSuccess(data);
  }

  //date validation check on hotel search
  const searchDateValidation = () => {
    setsearchResult([]);
    setTimeout(() => {
      setOverlay(false)
    }, 500);
  }

  // Track the last search to prevent duplicate searches
  const lastSearchSignature = useRef('');

  //hotel branch search api
  // Modified to accept explicit parameters when called from URL handler
  const searchHotelBranch = (directSearchData = null, ignoreTag = false) => {
    // If we're in the middle of a manual search operation triggered by URL params,
    // and this is a call without directSearchData (from a component), skip it
    if (window.manualSearchTrigger && !directSearchData) {
      // console.log('Skipping redundant search during manual search operation');
      return;
    }

    // Use direct search data if provided (from URL parameters), otherwise use Redux state
    const searchData = directSearchData || props.userSearchDataFromReducer;
    if (searchData) {
      setSearchingDataFromSearchPanel(searchData);
    }

    const currentDestination = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || selectedDestination || '';
    const currentTheme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || selectedTheme || '';
    const currentNavTag = selectedNavTag || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('selectedNavTag') : '') || '';
    const urlTag = new URLSearchParams(window.location.search).get('tag') || '';
    const activeTag = ignoreTag ? '' : (urlTag || currentDestination || currentTheme || currentNavTag || '');
    const tags = activeTag ? [Utility.getTagByKey(activeTag)] : [];

    // Create a search signature for deduplication
    const searchSignature = JSON.stringify({
      destination: searchData?.destination,
      start_date: searchData?.start_date?.toString(),
      end_date: searchData?.end_date?.toString(),
      adult: searchData?.adult,
      children: searchData?.children,
      children_age: JSON.stringify(searchData?.children_age || []),
      tour_type: searchData?.tour_type,
      property_type: searchData?.property_type,
      filterData: JSON.stringify(searchData?.filterData || {}),
      tags: tags.join(",")
    });

    // Check if this is a duplicate search
    // if (searchSignature === lastSearchSignature.current) {
    //   // console.log('Skipping duplicate search with identical parameters');
    //   return;
    // }

    // Update the last search signature
    lastSearchSignature.current = searchSignature;

    // console.log('searchHotelBranch using source:', directSearchData ? 'Direct URL data' : 'Redux state', searchData);
    const { loaderStateTrue, loaderStateFalse } = props;
    setOverlay(true)
    setsearchResult([]);

    // IMPORTANT: Set the flag HERE (before setTimeout) so the URL-change useEffect
    // sees it immediately and does NOT call handleUrlParams() when history.replace fires.
    isFilterTriggeredUrlChange.current = true;

    setTimeout(() => {
      setApiCallFinish(false);

      // Dataset creation directly using searchData passed via props/state without modifying the URL
      let formattedData = serachDataFormatingFn(searchData);
      if (props.trendingDestinationData && props.trendingDestinationData.hasOwnProperty('type') && props.trendingDestinationData.type && props.trendingDestinationData.type == 'state') {
        if (searchData.destination && searchData.destination != "" && (typeof searchData.destination === 'object' ? Object.keys(searchData.destination).length > 0 : true)) {
          formattedData['location'] = searchData.destination;
        }
        formattedData['state'] = props.trendingDestinationData?.location;
      } else {
        if (searchData.destination && searchData.destination != "" && (typeof searchData.destination === 'object' ? Object.keys(searchData.destination).length > 0 : true)) {
          formattedData['location'] = searchData.destination;
        }
      }

      const currentDestination = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || selectedDestination || '';
      const currentTheme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || selectedTheme || '';
      const currentNavTag = selectedNavTag || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('selectedNavTag') : '') || '';
      const urlTag = new URLSearchParams(history?.location?.search || window.location.search).get('tag') || '';
      const activeTag = ignoreTag ? '' : (urlTag || currentDestination || currentTheme || currentNavTag || '');
      const tags = activeTag ? [Utility.getTagByKey(activeTag)] : [];

      let customerSearchHash = {};
      if (formattedData.customer_search_hash) {
        try {
          customerSearchHash = typeof formattedData.customer_search_hash === 'string'
            ? JSON.parse(formattedData.customer_search_hash)
            : formattedData.customer_search_hash;
        } catch (e) {
          customerSearchHash = {};
        }
      }

      if (tags.length > 0) {
        customerSearchHash['tags'] = tags;
      }

      if (Object.keys(customerSearchHash).length > 0) {
        formattedData['customer_search_hash'] = JSON.stringify(customerSearchHash);
      }

      const urlParams = new URLSearchParams(history?.location?.search || window.location.search);
      const urlCountry = urlParams.get('country') || searchData?.country;
      if (urlCountry) {
        formattedData['country'] = urlCountry;
        if (!urlParams.get('destination') && !urlParams.get('location')) {
          delete formattedData['location'];
        }
      }

      hotelRoomTypesSearchList(formattedData).then(async (response) => {
        if (response.success) {
          if (response.success) {
            let newDataSet = await formatingSearchData(response.data);
            setsearchResult(newDataSet)
            // Persist the correct searchData back to Redux so SearchPanel
            // sync useEffect does not overwrite local guest counts.
            props.userSearchData(searchData);
            setTimeout(() => {
              setOverlay(false)
            }, 500);
          }
        } else {
          Utility.toastNotifications("Data not found", "Warning", "warning");
        }
      }).catch((error) => {
        console.error("************error*************", error)
        if (error) {
        }
        setApiCallFinish(true)
        setTimeout(() => {
          setOverlay(false)
        }, 500);

        if (error.message == "Network Error") {
        }
      });
    }, 500);
  }

  //after geting branch search result
  useEffect(() => {
    const { loaderStateTrue, loaderStateFalse, userSearchDataFromReducer } = props;
    if (searchResult) {
      setApiCallFinish(true)
    }
  }, [searchResult]);


  //formatting branch data from search response
  const formatingSearchData = async (data) => {
    let branchArray = [];
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        for (let b = 0; b < data[i].branch_details.length; b++) {
          let newKeydata = data[i].branch_details[b];
          newKeydata["hotel_details"] = data[i].hotel_details
          branchArray.push(newKeydata)
        }
      }
    }
    return branchArray;
  }

  // Callback function to receive data from the FilterPanel child component
  const receiveDataFromFilterPanel = (data) => {
    setDataFromFilterPanel(data);
  };

  //breadcrumb menu click fn
  const homeMenuClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
  }
  const hotelListClick = () => {
    const params = new URLSearchParams(history?.location?.search || window.location.search);
    params.delete('tag');

    // Clear any stored tag selections so the property list reloads unfiltered
    setSelectedDestination('');
    setSelectedTheme('');
    setSelectedNavTag('');
    ['selectedDestination', 'selectedTheme', 'selectedNavTag'].forEach((key) => {
      localStorage.removeItem(key);
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(key);
      }
    });
    if (props.selectedNavTagAction) {
      props.selectedNavTagAction('');
    }

    props.history.push(`/${localStorage.getItem('i18nextLng')}/search${params.toString() ? `?${params.toString()}` : ''}`);
    setTimeout(() => searchHotelBranch(null, true), 0);
  }
  const hotelDetailsClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/property-details`);
  }

  const bookingListClick = () => {
    props.history.push(`/${localStorage.getItem('i18nextLng')}/booking-history`);
  }

  //when land on search page scroll to top position
  useEffect(() => {
    console.log('Search page mounted, checking URL parameters');
    breadcrumbUrlFn();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);

    // Redirect home only when landing with no search context at all
    const mountParams = new URLSearchParams(history?.location?.search || window.location.search);
    const hasMountUrlData = mountParams.get('startDate') || mountParams.get('start_date') || mountParams.get('adult');
    const red = props.userSearchDataFromReducer || {};
    const hasReduxData = red.start_date && red.start_date != "" && red.end_date && red.end_date != "" && red.adult && red.adult != "";
    if (!hasMountUrlData && !hasReduxData) {
      props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
      return;
    }

    // Initial parse of URL parameters when component first mounts
    handleUrlParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount

  // Track the last processed URL search params to avoid duplicate processing
  const lastProcessedUrlParams = useRef('');

  // Separate effect to monitor URL changes
  useEffect(() => {
    // Only process URL changes that aren't triggered internally by filter updates
    // and only if there are actually search parameters in the URL
    const currentUrlParams = history.location.search;

    if (!isFilterTriggeredUrlChange.current &&
      currentUrlParams &&
      currentUrlParams !== lastProcessedUrlParams.current) {

      // console.log('External URL change detected, updating parameters');
      // Save this URL to prevent reprocessing the same URL
      lastProcessedUrlParams.current = currentUrlParams;
      handleUrlParams();
    } else {
      // Reset the flag after ignoring this update
      // IMPORTANT: Also update lastProcessedUrlParams so we don't process it later!
      lastProcessedUrlParams.current = currentUrlParams;
      isFilterTriggeredUrlChange.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search]); // Re-run when URL changes using history.location

  // Separate function to handle URL parameters
  const handleUrlParams = async () => {
    const searchData = Utility.decodeUrlParams(history.location.search);

    if (["destination", "start_date", "end_date", "adult", "country"].some(key => searchData.hasOwnProperty(key) && searchData[key])) {

      // IMPORTANT: Only update Redux state with the URL parameters
      // The existing useEffect that watches for Redux state changes will trigger the search
      // console.log('Updating Redux with URL parameters:', searchData);

      // First store the current Redux state
      const currentState = props.userSearchDataFromReducer || {};

      // Create a complete copy of state to ensure we don't lose any fields
      // and explicitly assign the values that we want to update from URL
      let mergedState = {
        ...currentState,
        // Explicitly assign these fields to ensure they're updated
        country: searchData.country || currentState.country || "",
        destination: searchData.destination || (searchData.country ? "" : currentState.destination) || "",
        start_date: searchData.start_date || currentState.start_date,
        end_date: searchData.end_date || currentState.end_date,
        adult: searchData.adult || currentState.adult,
        children: searchData.children !== undefined ? searchData.children : currentState.children || 0,
        // Make sure we're explicitly setting the children_age array 
        children_age: (searchData.children_age && searchData.children_age.length > 0) ? searchData.children_age : currentState.children_age || [],
        tour_type: searchData.tour_type || currentState.tour_type || "hotel",
        property_type: searchData.property_type || currentState.property_type || "hotel",
        filterData: {
          ...(currentState.filterData || {}),
          ...(searchData.filterData || {}),
          ...(searchData.property_type ? { property_type: searchData.property_type } : {})
        }
      };

      // Validate the URL destination if a state is selected
      if (props.trendingDestinationData && props.trendingDestinationData.type === 'state' && mergedState.destination) {
        try {
          const destResponse = await destinationList({
            type: 'state',
            type_name: props.trendingDestinationData.location
          });
          const locationListData = (destResponse?.data || []).map(item => {
            if (typeof item === 'string') return { label: item, value: item };
            return {
              label: item.label || item.value || item.location || item.name || item.city || item.state || '',
              value: item.value || item.label || item.location || item.name || item.city || item.state || ''
            };
          });
          const destText = (mergedState.destination?.label || mergedState.destination || '').toString().toLowerCase();
          const matched = locationListData.find(item => {
            const value = (item.value || '').toString().toLowerCase();
            const label = (item.label || '').toString().toLowerCase();
            return value === destText || label === destText || destText.includes(value) || value.includes(destText) || destText.includes(label) || label.includes(destText);
          });
          if (!matched) {
            mergedState.destination = '';
            const searchParams = new URLSearchParams(history.location.search);
            if (searchParams.has('location')) {
              searchParams.delete('location');
              const newSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';
              const currentPath = history.location.pathname;
              lastProcessedUrlParams.current = newSearch;
              isFilterTriggeredUrlChange.current = true;
              history.replace(`${currentPath}${newSearch}`);
            }
          }
        } catch (err) {
          // If validation API fails, proceed with the original destination
        }
      }

      // console.log('Updating Redux with URL parameters mergedState:', mergedState);
      // Create a signature of current state to compare with existing Redux state
      const currentStateSignature = JSON.stringify({
        country: mergedState.country,
        destination: mergedState.destination,
        start_date: mergedState.start_date?.toString(),
        end_date: mergedState.end_date?.toString(),
        adult: mergedState.adult,
        children: mergedState.children,
        children_age: JSON.stringify(mergedState.children_age || []),
        tour_type: mergedState.tour_type,
        property_type: mergedState.property_type,
        filterData: JSON.stringify(mergedState.filterData || {})
      });

      // Get a signature of the existing Redux state for comparison
      const existingStateSignature = JSON.stringify({
        country: props.userSearchDataFromReducer?.country,
        destination: props.userSearchDataFromReducer?.destination,
        start_date: props.userSearchDataFromReducer?.start_date?.toString(),
        end_date: props.userSearchDataFromReducer?.end_date?.toString(),
        adult: props.userSearchDataFromReducer?.adult,
        children: props.userSearchDataFromReducer?.children,
        children_age: JSON.stringify(props.userSearchDataFromReducer?.children_age || []),
        tour_type: props.userSearchDataFromReducer?.tour_type,
        property_type: props.userSearchDataFromReducer?.property_type,
        filterData: JSON.stringify(props.userSearchDataFromReducer?.filterData || {})
      });

      // Only update Redux if the state is actually different
      if (currentStateSignature !== existingStateSignature) {
        // console.log('URL params different from Redux state, updating Redux...');
        // Update Redux with the merged state
        props.userSearchData(mergedState);

        if (!(mergedState.start_date && mergedState.end_date && mergedState.adult)) {
          // console.log('Not enough data in URL parameters to perform a valid search');
          return;
        }

        // Only perform a search if we have all required data and it's not already in progress
        // console.log('Performing search based on URL parameters');

        // Set a flag to indicate we're manually triggering a search and should skip further updates
        window.manualSearchTrigger = true;

        // We need to directly call searchHotelBranch with the mergedState to ensure it has the latest data
        // Call just once - the searchHotelBranch function now has its own deduplication
        searchHotelBranch(mergedState);

        // Reset the flag after a delay to allow future searches
        setTimeout(() => {
          window.manualSearchTrigger = false;
        }, 1000);
      } else {
        // console.log('URL params match Redux state, skipping update');
      }
    }
  };

  // Get dynamic destination name for the heading
  const getDestinationName = () => {
    const dest = props.userSearchDataFromReducer?.destination ||
      searchingDataFromSearchPanel?.destination;
    let name = '';
    if (dest) {
      if (typeof dest === 'string' && dest.trim() !== '') {
        name = dest.trim();
      } else if (typeof dest === 'object') {
        if (dest.label && typeof dest.label === 'string') {
          name = dest.label.trim();
        } else if (dest.value && typeof dest.value === 'string') {
          name = dest.value.trim();
        } else {
          const firstStr = Object.values(dest).find(v => typeof v === 'string' && v.trim() !== '');
          if (firstStr) name = firstStr.trim();
        }
      }
    }

    if (!name) {
      const urlParams = new URLSearchParams(props.location?.search || window.location.search);
      name = urlParams.get('destination') || urlParams.get('location') || urlParams.get('city') || urlParams.get('country') || '';
    }

    if (!name && props.trendingDestinationData?.location) {
      name = props.trendingDestinationData.location;
    }

    return name ? Utility.capitalizeFirstLetterOfEachWord(name) : '';
  };

  //breadcrumb menu option function
  const breadcrumbUrlFn = () => {
    try {
      // Safely get and parse pageArr from localStorage
      let breadcrumb = [];
      const pageArrString = localStorage.getItem('pageArr');
      if (pageArrString) {
        try {
          breadcrumb = JSON.parse(pageArrString);
          // Ensure breadcrumb is an array
          if (!Array.isArray(breadcrumb)) {
            breadcrumb = [];
          }
        } catch (e) {
          // If parsing fails, initialize as empty array
          breadcrumb = [];
        }
      }

      // Find search index safely
      const searchIndex = breadcrumb.indexOf('search');
      let newArray = searchIndex >= 0 ? breadcrumb.slice(0, searchIndex + 1) : breadcrumb;

      if (!breadcrumb.includes('search')) {
        breadcrumb.push('search');
        localStorage.setItem('pageArr', JSON.stringify(breadcrumb));
      } else {
        localStorage.setItem('pageArr', JSON.stringify(newArray));
      }
    } catch (error) {
      // Fallback if anything goes wrong
      console.error('Error in breadcrumb handling:', error);
      try {
        localStorage.setItem('pageArr', JSON.stringify(['search']));
      } catch (e) {
        // Last resort if localStorage is unavailable
        console.error('Failed to access localStorage:', e);
      }
    }
  }

  //view cancellation details data set
  const viewCancellationDetails = (data) => {
    setViewCancellationData(data);
  }

  // Removed the useEffect that forced componentKey updates on URL changes,
  // as it caused SearchPanel/FilterPanel to unmount and remount, resulting in flickering
  // and state resets.
  const lastUrlParams = useRef('');

  useEffect(() => {
    if (viewCancellationData.length > 0) {
      setViewCancellationDetailsModalFlag(true)
    }
  }, [viewCancellationData])

  //cancellation details modal close fn
  const closeCancellationDetailsModalFn = () => {
    setViewCancellationData([])
    setViewCancellationDetailsModalFlag(false)
  }

  const breadcrumbTag = (() => {
    const t = new URLSearchParams(window.location.search).get('tag') ||
      localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') ||
      localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') ||
      selectedNavTag || sessionStorage.getItem('selectedNavTag') || '';
    if (!t) return '';
    const mapped = Utility.getKeyByTags(t);
    return mapped !== t ? mapped : String(t).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  })();

  return (
    <>
      {overlay &&
        <div className='overlayBox'></div>}
      <div className='searchPageBox staying-home-redesign'>
        <div className='searchPanel searchPanelInner'>
          <SearchPanel
            searchDateValidation={searchDateValidation}
            callFrom="search"
            searchHotelBranch={searchHotelBranch}
          />
        </div>
        <div className='clearfix'></div>
        <div className='breadcrumbPanelSec'>
          <div className='container'>
            <BreadcrumbMenu
              homeMenuDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('home') : false}
              hotelListDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('search') : false}
              hotelDetailsDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('hotel-details') : false}
              bookingListDisplay={localStorage.getItem('pageArr') ? JSON.parse(localStorage.getItem('pageArr') || '[]').includes('booking-history') : false}
              homeMenuClick={homeMenuClick}
              hotelListClick={hotelListClick}
              hotelDetailsClick={hotelDetailsClick}
              bookingListClick={bookingListClick}
              activeHotelList={true}
              tags={breadcrumbTag}
            />
          </div>
        </div>
        <div className='searchBodyPanel'>
          <div className='container'>
            <div className='innSearchBodyPanel'>
              <div className='row'>
                <div className='mob-filter'>
                  <button onClick={() => { mobFilterFN() }}><i className="fa fa-filter" aria-hidden="true"></i>
                    Filter</button>
                </div>

                <FilterPanel
                  leftSearchFlag={leftSearchFlag}
                  crossFN={crossFN}
                  sendDataToParent={receiveDataFromFilterPanel}
                  searchHotelBranch={searchHotelBranch}
                  filterApiSuccessCheckFn={filterApiSuccessCheckFn}
                />
                {apiCallFinish ?
                  <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 hotelList">
                    <div className='searchRight'>
                      {/* {searchingDataFromSearchPanel.start_date && searchingDataFromSearchPanel.start_date != "" && searchingDataFromSearchPanel.end_date && searchingDataFromSearchPanel.end_date != "" && */}
                      <h6>Explore {searchResult?.length > 0 ? `${searchResult.length}+` : 0} Places {getDestinationName() ? `in ${getDestinationName()}` : ''}</h6>
                      <div className='hotelListBoxes'>
                        <HotelListItems searchResult={searchResult} {...props} adult={searchingDataFromSearchPanel.adult} child={searchingDataFromSearchPanel.children} start_date={searchingDataFromSearchPanel.start_date} end_date={searchingDataFromSearchPanel.end_date} showReviewModalFn={showReviewModalFn} apiCallFinish={apiCallFinish
                        } viewCancellationDetails={viewCancellationDetails} />
                      </div>
                    </div>
                  </div> :
                  <SkeletonThemeContentList />
                }
              </div>
            </div>
          </div>
        </div>
        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={reviewShowModalFlag}
            onHide={closeReviewModalFn}
            title="Review"
            className="modalcustomize mondimension reviewDialogModal"
            footer={false}
            closeButton={true}
            saveButtonLabel="Submit"
            saveButtonClassName="modbtn savebtn"
            cancelShow={false}
            saveShow={false}
            onCancel={closeReviewModalFn}
            cancelButtonClassName="modbtn cancelbtn"
            footerClassName="text-center topspace"
            body={
              <>
                <ErrorBoundary title="ReviewContentShowModal Error">
                  <ReviewContentShowModal
                    ratingData={ratingDataArr}
                  />
                </ErrorBoundary>
              </>
            }
          />
        </ErrorBoundary>

        <ErrorBoundary title="ModalGlobal Error">
          <ModalGlobal
            show={viewCancellationDetailsModalFlag}
            onHide={closeCancellationDetailsModalFn}
            title={viewCancellationData.length > 1 ? "Cancellation Rules" : 'Cancellation Rule'}
            className="modalcustomize mondimension reviewDialogModal cancellationRuleModal"
            footer={false}
            closeButton={true}
            saveButtonLabel="Submit"
            saveButtonClassName="modbtn savebtn"
            cancelShow={false}
            saveShow={false}
            onCancel={closeCancellationDetailsModalFn}
            cancelButtonClassName="modbtn cancelbtn"
            footerClassName="text-center topspace"
            body={
              <>
                <ErrorBoundary title="cancellation details Error">
                  <CancellationDetailsModalContent
                    viewCancellationData={viewCancellationData}
                  />
                </ErrorBoundary>
              </>
            }
          />
        </ErrorBoundary>
      </div>
    </>
  );

}
const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
    trendingDestinationData: globalState.mainReducerData.trendingDestination,
    selectedNavTagFromReducer: globalState.mainReducerData?.selectedNavTag,
  };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, logOutApp, roleWisePermission, userSearchData, setToken, selectChooseBranch })(SearchPage);
